import { dashboardv99990101Client } from '@sequencehq/api/dashboard/v99990101'

import { AutomationsPresentationV1 } from 'Automations/automationEditor/types'
import { ResolvedNodeDefinitions } from 'Automations/nodeDefinitions/types'
import { presentationToVersionParams } from '../presentationToVersionParams'

export const saveAutomationVersion = async ({
  automationId,
  name,
  description,
  presentation,
  definitions,
  changelog
}: {
  automationId: string
  name: string
  description: string
  presentation: AutomationsPresentationV1
  definitions: ResolvedNodeDefinitions
  changelog: string
}) => {
  const { apiPresentation, workflowDefinition, triggerType } =
    presentationToVersionParams({
      name,
      description,
      presentation,
      definitions
    })

  const resNewVersion = await dashboardv99990101Client.postAutomationVersion({
    automationId,
    body: {
      presentation: apiPresentation,
      workflowDefinition,
      triggerType,
      changelog
    }
  })

  if (!resNewVersion.data || resNewVersion.error) {
    throw new Error('Unable to create automation version')
  }

  return resNewVersion.data
}
